/**
 * @description http://stackoverflow.com/questions/14833326/how-to-set-focus-on-input-field#answer-18295416
 */
;(function () {
  angular.module('contrast.form').directive('focusOn', function ($timeout) {
    'ngInject'

    return function (scope, elem, attr) {
      scope.$on(attr.focusOn, function () {
        $timeout(function () {
          elem[0].focus()
        })
      })
    }
  })
})()
